import type { FormEditFormStateType } from 'types/page/formEditFormStateType';

export interface ImageGeneratorItem {
  key: string;
  name: string;
  title: string | null;
  description: string | null;
  imageKey: string | null;
}

export interface AppliedImageResult {
  imageKey: string | null;
  questions: FormEditFormStateType['questions'];
  results: FormEditFormStateType['results'];
}

export function buildImageGeneratorItems(values: FormEditFormStateType): ImageGeneratorItem[] {
  const items: ImageGeneratorItem[] = [];

  items.push({
    key: 'title',
    name: 'タイトル',
    title: values.title ?? null,
    description: values.title ?? null,
    imageKey: values.imageKey ?? null,
  });

  values.questions.forEach((question, index) => {
    items.push({
      key: `question_${index}`,
      name: `設問${index + 1}`,
      title: question.title ?? null,
      description: null,
      imageKey: question.questionImageKey ?? null,
    });
  });

  values.results.forEach((result, index) => {
    items.push({
      key: `result_${index}`,
      name: `結果${index + 1}`,
      title: result.title ?? null,
      description: result.descriptionHtml ?? null,
      imageKey: result.imageKey ?? null,
    });
  });

  return items;
}

export function applyGeneratedImages(
  values: FormEditFormStateType,
  generatedImages: { key: string; imageKey: string }[]
): AppliedImageResult {
  const updatedTitle = generatedImages.find(img => img.key === 'title');
  const imageKey = updatedTitle ? updatedTitle.imageKey : (values.imageKey ?? null);

  const questions = values.questions.map((question, index) => {
    const generated = generatedImages.find(img => img.key === `question_${index}`);
    if (generated) {
      return { ...question, questionImageKey: generated.imageKey };
    }
    return question;
  });

  const results = values.results.map((result, index) => {
    const generated = generatedImages.find(img => img.key === `result_${index}`);
    if (generated) {
      return { ...result, imageKey: generated.imageKey };
    }
    return result;
  });

  return { imageKey, questions, results };
}
